import {EventEmitter, Injectable, Output} from '@angular/core';
import {ConfService} from './conf.service';
import {LeftpanelComponent} from './leftpanel/leftpanel.component';

@Injectable({
  providedIn: 'root'
})
export class DatacatalogListenerService {

  @Output() dataCatalogListener: EventEmitter<any> = new EventEmitter();


  constructor() {
    this.dataCatalogListener.subscribe(
        (eventObject) => {
          // This listener has to be removed
        }
    );
  }
}
